<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'contact-us',
          title: 'Contact Us',
          active: 1,
          image: '',
          color: 'gray-100',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          icon: 'ri:mail-open-line',
          icon_color: 'revinre',
          h2: 'Get in touch',
          h2_color: '',
          h2_desc: 'We are here to answer any questions you might have. Please feel free to reach out by email, contact form, phone or chat.',
          h2_desc_color: '',
          pre_btn: [],
          map_google_style: "[ { \"featureType\": \"administrative\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#6195a0\" } ] }, { \"featureType\": \"administrative.province\", \"elementType\": \"geometry.stroke\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"landscape\", \"elementType\": \"geometry\", \"stylers\": [ { \"lightness\": \"0\" }, { \"saturation\": \"0\" }, { \"color\": \"#f5f5f2\" }, { \"gamma\": \"1\" } ] }, { \"featureType\": \"landscape.man_made\", \"elementType\": \"all\", \"stylers\": [ { \"lightness\": \"-3\" }, { \"gamma\": \"1.00\" } ] }, { \"featureType\": \"landscape.natural.terrain\", \"elementType\": \"all\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"poi\", \"elementType\": \"all\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"poi.park\", \"elementType\": \"geometry.fill\", \"stylers\": [ { \"color\": \"#bae5ce\" }, { \"visibility\": \"on\" } ] }, { \"featureType\": \"road\", \"elementType\": \"all\", \"stylers\": [ { \"saturation\": -100 }, { \"lightness\": 45 }, { \"visibility\": \"simplified\" } ] }, { \"featureType\": \"road.highway\", \"elementType\": \"all\", \"stylers\": [ { \"visibility\": \"simplified\" } ] }, { \"featureType\": \"road.highway\", \"elementType\": \"geometry.fill\", \"stylers\": [ { \"color\": \"#fac9a9\" }, { \"visibility\": \"simplified\" } ] }, { \"featureType\": \"road.highway\", \"elementType\": \"labels.text\", \"stylers\": [ { \"color\": \"#4e4e4e\" } ] }, { \"featureType\": \"road.arterial\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#787878\" } ] }, { \"featureType\": \"road.arterial\", \"elementType\": \"labels.icon\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"transit\", \"elementType\": \"all\", \"stylers\": [ { \"visibility\": \"simplified\" } ] }, { \"featureType\": \"transit.station.airport\", \"elementType\": \"labels.icon\", \"stylers\": [ { \"hue\": \"#0a00ff\" }, { \"saturation\": \"-77\" }, { \"gamma\": \"0.57\" }, { \"lightness\": \"0\" } ] }, { \"featureType\": \"transit.station.rail\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#43321e\" } ] }, { \"featureType\": \"transit.station.rail\", \"elementType\": \"labels.icon\", \"stylers\": [ { \"hue\": \"#ff6c00\" }, { \"lightness\": \"4\" }, { \"gamma\": \"0.75\" }, { \"saturation\": \"-68\" } ] }, { \"featureType\": \"water\", \"elementType\": \"all\", \"stylers\": [ { \"color\": \"#eaf6f8\" }, { \"visibility\": \"on\" } ] }, { \"featureType\": \"water\", \"elementType\": \"geometry.fill\", \"stylers\": [ { \"color\": \"#c7eced\" } ] }, { \"featureType\": \"water\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"lightness\": \"-49\" }, { \"saturation\": \"-53\" }, { \"gamma\": \"0.79\" } ] } ]",
          map_locations: [
            { latitude: '33.6845827', longitude: '-111.9244888' },
            { latitude: '42.91516520015457', longitude: '-77.3375256457495' }
          ],
          phone_required: 1,
          btn_color: 'revinre',
          btn_pre_icon: 'ri:mail-send-line',
          btn_text: 'Submit',
          btn_post_icon: '',

          contact_bg: 'white',
          contact_title_color: 'black',
          contact_text_color: 'muted',
          contact_icon_color: 'revinre',
          contact_locations_icon: 'ri:road-map-line',
          contact_locations: ['AZ', 'NY'],
          contact_emails_icon: 'ri:mail-line',
          contact_emails: ['support@revinre.com'],
          contact_phones_icon: 'ri:smartphone-line',
          contact_phones: ['6025627222'],
          
          post_btn: [],
        },

        loading: false,
        completed: false,
        input_form: {
          name: '',
          email: '',
          phone: '',
          comments: '',
          recaptcha_token: '',
        },
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }
      if(!this.pc.map_locations) { this.pc.map_locations = []; this.$forceUpdate(); }
      if(!this.pc.contact_locations) { this.pc.contact_locations = []; this.$forceUpdate(); }
      if(!this.pc.contact_emails) { this.pc.contact_emails = []; this.$forceUpdate(); }
      if(!this.pc.contact_phones) { this.pc.contact_phones = []; this.$forceUpdate(); }

      if(this.type != 'editor') {
        if(this.user && this.user.name) { this.input_form.name = this.user.name; }
        if(this.user && this.user.email) { this.input_form.email = this.user.email; }
        if(this.user && this.user.phone) { this.input_form.phone = this.user.phone; }
      }
    },
    methods: {
      async submit_form() {
        // history.pushState({}, null, '/valuation');
        if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
        this.input_form.recaptcha_token = await this.getRecaptcha();
        if(
          !this.input_form.recaptcha_token ||
          this.input_form.recaptcha_token == 'failed'
        ) {
          this.$noty.error("There was an issue with the Google ReCaptcha validation. Please try submitting the form again. If that does not work, try refreshing the page. If this does not solve the issue, please reach out to us.");
          this.loading = false; return;
        }
        if(
          !this.input_form.name ||
          !this.input_form.email ||
          (this.pc['phone_required'] && !this.input_form.phone)
        ) {
          this.$noty.error("Please enter a full name, email address and phone number before continuing.");
          this.loading = false; return;
        }
        this.$http.post('/inbox/contact-us', this.input_form).then(res => {
          console.log(res);
          this.completed = true;
          this.loading = false;
        }).catch(res => { console.log(res); this.loading = false; this.popupErrors(res); });
      },
      convertMapStyle() {
        var StaticParams = (function(){
            var _items = [], separator = '|', _parameters = '';
            function isColor(value){return /^#[0-9a-f]{6}$/i.test(value.toString());}
            function toColor(value){return '0x' + value.slice(1);}
            function parse(jsonString){
              var json;
              try { json = JSON.parse(jsonString); } catch (e){ return; }
              _items.length = 0;
              for(var i = 0; i < json.length; i++){
                var item = json[i], hasFeature = item.hasOwnProperty('featureType'), hasElement = item.hasOwnProperty('elementType'), stylers = item.stylers, target = '', style = '';
                if(!hasFeature && !hasElement){ target = 'feature:all'; }
                else { if(hasFeature){ target = 'feature:' + item.featureType; } if(hasElement){ target = target ? target + separator : ''; target += 'element:' + item.elementType; } }
                for(var s = 0; s< stylers.length; s++){ var styleItem = stylers[s], key = Object.keys(styleItem)[0]; style = style ? style + separator : ''; style += key + ':' + (isColor(styleItem[key]) ? toColor(styleItem[key]) : styleItem[key]); }
                _items.push(target + separator + style);
              }
            }
            return { get: function(){return '&style=' + _items.join('&style=');}, parse: parse }
        })();
        if(this.pc && this.pc.map_google_style) {
          StaticParams.parse(this.pc.map_google_style);
          return StaticParams.get();
        } else {
          return '&style=feature%3Aadministrative%7Celement%3Alabels.text.fill%7Ccolor%3A0x6195a0%7C&style=feature%3Aadministrative.province%7Celement%3Ageometry.stroke%7Cvisibility%3Aoff%7C&style=feature%3Alandscape%7Celement%3Ageometry%7Clightness%3A0%7Csaturation%3A0%7Ccolor%3A0xf5f5f2%7Cgamma%3A1%7C&style=feature%3Alandscape.man_made%7Celement%3Aall%7Clightness%3A-3%7Cgamma%3A1.00%7C&style=feature%3Alandscape.natural.terrain%7Celement%3Aall%7Cvisibility%3Aoff%7C&style=feature%3Apoi%7Celement%3Aall%7Cvisibility%3Aoff%7C&style=feature%3Apoi.park%7Celement%3Ageometry.fill%7Ccolor%3A0xbae5ce%7Cvisibility%3Aon%7C&style=feature%3Aroad%7Celement%3Aall%7Csaturation%3A-100%7Clightness%3A45%7Cvisibility%3Asimplified%7C&style=feature%3Aroad.highway%7Celement%3Aall%7Cvisibility%3Asimplified%7C&style=feature%3Aroad.highway%7Celement%3Ageometry.fill%7Ccolor%3A0xfac9a9%7Cvisibility%3Asimplified%7C&style=feature%3Aroad.highway%7Celement%3Alabels.text%7Ccolor%3A0x4e4e4e%7C&style=feature%3Aroad.arterial%7Celement%3Alabels.text.fill%7Ccolor%3A0x787878%7C&style=feature%3Aroad.arterial%7Celement%3Alabels.icon%7Cvisibility%3Aoff%7C&style=feature%3Atransit%7Celement%3Aall%7Cvisibility%3Asimplified%7C&style=feature%3Atransit.station.airport%7Celement%3Alabels.icon%7Chue%3A0x0a00ff%7Csaturation%3A-77%7Cgamma%3A0.57%7Clightness%3A0%7C&style=feature%3Atransit.station.rail%7Celement%3Alabels.text.fill%7Ccolor%3A0x43321e%7C&style=feature%3Atransit.station.rail%7Celement%3Alabels.icon%7Chue%3A0xff6c00%7Clightness%3A4%7Cgamma%3A0.75%7Csaturation%3A-68%7C&style=feature%3Awater%7Celement%3Aall%7Ccolor%3A0xeaf6f8%7Cvisibility%3Aon%7C&style=feature%3Awater%7Celement%3Ageometry.fill%7Ccolor%3A0xc7eced%7C&style=feature%3Awater%7Celement%3Alabels.text.fill%7Clightness%3A-49%7Csaturation%3A-53%7Cgamma%3A0.79%7C';
        }
      },
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Map Locations :</h6>
        <div class="row">
          <div class="col-sm-12">
            <w-field SimpleDataType="Textarea" v-model="pc.map_google_style" Title="Google maps style snippet :" v-tippy content=""></w-field>
          </div>
          <div class="col-sm-12">
            <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.map_locations">
              <transition-group tag="div">
                <div v-for="(loc, loc_i) in pc.map_locations" :key="'l'+loc_i">
                  <div class="row m-0 align-items-end">
                    <div class="col-2 p-0">
                      <w-field SimpleDataType="String" v-model="loc.latitude" Title="Latitude :"></w-field>
                    </div>
                    <div class="col p-0">
                      <w-field SimpleDataType="String" v-model="loc.longitude" Title="Longitude :"></w-field>
                    </div>
                    <div class="_w-40 pb-2">
                      <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.map_locations.splice(loc_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                    </div>
                    <div class="_w-40 pb-2">
                      <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <button class="btn btn-sm btn-primary" type="button" @click="pc.map_locations.push({latitude: '', longitude: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add location</button>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Contact Form :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.phone_required" Title="Require phone? : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.btn_color" Title="Button color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.btn_pre_icon" Title="Button pre icon : "></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.btn_text" Title="Button text : "></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.btn_post_icon" Title="Button post icon : "></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Contact Details :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.contact_bg" Title="Box backgorund color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.contact_title_color" Title="Box title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.contact_text_color" Title="Box text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.contact_icon_color" Title="Box icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-12"><hr></div>
          <div class="col-sm-12">
            <w-field SimpleDataType="String" v-model="pc.contact_locations_icon" Title="Locations icon : "></w-field>
          </div>
          <div class="col-sm-12">
            <label>Locations : </label>
            <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.contact_locations">
              <transition-group tag="div">
                <div v-for="(loc, loc_i) in pc.contact_locations" :key="'l'+loc_i">
                  <div class="row m-0 align-items-end">
                    <div class="col p-0">
                      <w-field SimpleDataType="String" v-model="pc.contact_locations[loc_i]" placeholder="Location..."></w-field>
                    </div>
                    <div class="_w-40 pb-2">
                      <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.contact_locations.splice(loc_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                    </div>
                    <div class="_w-40 pb-2">
                      <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <button class="btn btn-sm btn-primary" type="button" @click="pc.contact_locations.push(''); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add location</button>
          </div>
          <div class="col-sm-12"><hr></div>
          <div class="col-sm-12">
            <w-field SimpleDataType="String" v-model="pc.contact_emails_icon" Title="Emails icon : "></w-field>
          </div>
          <div class="col-sm-12">
            <label>Emails : </label>
            <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.contact_emails">
              <transition-group tag="div">
                <div v-for="(loc, loc_i) in pc.contact_emails" :key="'l'+loc_i">
                  <div class="row m-0 align-items-end">
                    <div class="col p-0">
                      <w-field SimpleDataType="String" v-model="pc.contact_emails[loc_i]" placeholder="Email..."></w-field>
                    </div>
                    <div class="_w-40 pb-2">
                      <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.contact_emails.splice(loc_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                    </div>
                    <div class="_w-40 pb-2">
                      <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <button class="btn btn-sm btn-primary" type="button" @click="pc.contact_emails.push(''); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add email</button>
          </div>
          <div class="col-sm-12"><hr></div>
          <div class="col-sm-12">
            <w-field SimpleDataType="String" v-model="pc.contact_phones_icon" Title="Phones icon : "></w-field>
          </div>
          <div class="col-sm-12">
            <label>Phones : </label>
            <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.contact_phones">
              <transition-group tag="div">
                <div v-for="(loc, loc_i) in pc.contact_phones" :key="'l'+loc_i">
                  <div class="row m-0 align-items-end">
                    <div class="col p-0">
                      <w-field SimpleDataType="String" v-model="pc.contact_phones[loc_i]" placeholder="Phone..."></w-field>
                    </div>
                    <div class="_w-40 pb-2">
                      <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.contact_phones.splice(loc_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                    </div>
                    <div class="_w-40 pb-2">
                      <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <button class="btn btn-sm btn-primary" type="button" @click="pc.contact_phones.push(''); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add phone </button>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

        <div class="row pb-5">
          <div class="col-sm-6 mb-5">
            <img v-if="pc['map_locations'] && pc['map_locations'].length" class="rounded border border-white _b-s-0 w-100 _box-shadow-0-1-10-b-2" :src="'https://maps.googleapis.com/maps/api/staticmap?center=39.8282,-98.5795&zoom=4&size=640x315&maptype=roadmap&markers=size:small|'+pc['map_locations'].map(b => { return b.latitude+','+b.longitude; }).join('|')+'&key='+google_key+convertMapStyle()" alt="Whether you are buying or selling our team of professionals are ready to help.">
          </div>
          <div class="col-lg-5 offset-lg-1 col-sm-6 mb-5">
            <div v-if="completed" class="alert alert-success text-center p-5">
              <div class="mb-4"><Icon icon="ri:mail-send-line" height="100" class="" /></div>Your message has been sent!
            </div>
            <form v-else @submit.prevent="submit_form" id="contact_us">
              <w-field class="mb-3" SimpleDataType="String" v-model="input_form.name" placeholder="Full name : " Size="lg" Required></w-field>
              <w-field class="mb-3" SimpleDataType="String" v-model="input_form.email" placeholder="Email address : " Size="lg" Required></w-field>
              <w-field class="mb-3" SimpleDataType="Phone" v-model="input_form.phone" placeholder="Phone Number : " Size="lg" :Required="!!parseInt(pc['phone_required'])"></w-field>
              <w-field class="mb-3" SimpleDataType="Textarea" v-model="input_form.comments" placeholder="Comments : " Size="lg" Required></w-field>
              <div class="small">
                <p class="small text-gray-700 mb-1">By submitting you agree to {{app_name}}'s <a href="/privacy" target="_blank">Privacy Policy</a> and <a href="/terms" target="_blank">Terms & Conditions</a>.</p>
                <p class="small text-gray-700 mb-2">This site is protected by ReCaptcha and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</p>
              </div>
              <button type="submit" class="btn btn-lg btn-block" :class="'btn-'+website_id" :disabled="loading"><span v-if="loading" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:mail-send-line" /> Submit</button>
            </form>
          </div>
        </div>

        <div class="row pt-4">
          <div class="col-sm-4">
            <div class="card mb-3" :class="'bg-'+pc['contact_bg']">
              <div class="row mx-0">
                <div class="col-3 align-self-center text-center"><Icon :icon="pc['contact_locations_icon']" :class="'text-'+pc['contact_icon_color']" height="50" /></div>
                <div class="col-9 py-4 pl-0 pr-4"><h4 class="mb-1" :class="'text-'+pc['contact_title_color']">Location(s)</h4><p v-for="(loc, loc_i) in pc['contact_locations']" :key="loc_i" class="mb-0" :class="'text-'+pc['contact_text_color']">{{ loc }}</p></div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card mb-3" :class="'bg-'+pc['contact_bg']">
              <div class="row mx-0">
                <div class="col-3 align-self-center text-center"><Icon :icon="pc['contact_emails_icon']" :class="'text-'+pc['contact_icon_color']" height="50" /></div>
                <div class="col-9 py-4 pl-0 pr-4"><h4 class="mb-1" :class="'text-'+pc['contact_title_color']">Email(s)</h4><p v-for="(email, email_i) in pc['contact_emails']" :key="email_i" class="mb-0" :class="'text-'+pc['contact_text_color']">{{ email }}</p></div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card mb-3" :class="'bg-'+pc['contact_bg']">
              <div class="row mx-0">
                <div class="col-3 align-self-center text-center"><Icon :icon="pc['contact_phones_icon']" :class="'text-'+pc['contact_icon_color']" height="50" /></div>
                <div class="col-9 py-4 pl-0 pr-4"><h4 class="mb-1" :class="'text-'+pc['contact_title_color']">Phone(s)</h4><p v-for="(phone, phone_i) in pc['contact_phones']" :key="phone_i" class="mb-0" :class="'text-'+pc['contact_text_color']">{{ formatPhone(phone) }}</p></div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>
